module.exports = __webpack_public_path__ + "media/assets/icons/ranking-icon-30ba507949583fbb16b68c8c045e89f5.svg";